import React, { useEffect, useState } from "react";
import LikedCard from "../Cards/LikedCard";

const Liked = () => {
  return <LikedCard />;
};

export default Liked;
